(function () {
  'use strict';
  if (window.MirjoMiriLauncherReady) return;
  window.MirjoMiriLauncherReady = true;
  const root = document.querySelector('[data-miri-launcher-root]');
  if (!root) return;
  const launcher = root.querySelector('[data-miri-launcher]');
  const summary = launcher.querySelector('summary');
  const dictionary = JSON.parse(root.querySelector('[data-miri-texts]').textContent);
  const T = text => dictionary[text] || text;
  let openTimeout;
  let requestedButton;
  launcher.hidden = false;
  window.$chatty = window.$chatty || [];
  window.$chatty.push(['on', 'sdk:ready', function () {
    window.$chatty.push(['do', 'launcher:hide']);
  }]);
  window.$chatty.push(['on', 'chat:opened', function () {
    clearTimeout(openTimeout);
    document.querySelectorAll('[data-miri-chat-status]').forEach(node => { node.textContent = ''; });
    launcher.open = false;
    launcher.hidden = true;
  }]);
  window.$chatty.push(['on', 'chat:closed', function () {
    launcher.hidden = false;
    window.$chatty.push(['do', 'launcher:hide']);
    if (requestedButton) {
      if (document.contains(requestedButton) && !launcher.contains(requestedButton)) requestedButton.focus({ preventScroll: true });
      else summary.focus({ preventScroll: true });
      requestedButton = null;
    }
  }]);
  function close(focus) {
    launcher.open = false;
    if (focus) summary.focus({ preventScroll: true });
  }
  root.querySelector('[data-miri-close]').addEventListener('click', () => close(true));
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && launcher.open) { event.preventDefault(); close(true); }
  });
  document.addEventListener('pointerdown', event => {
    if (launcher.open && !launcher.contains(event.target)) close(false);
  });
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-miri-chat]');
    if (!button) return;
    const container = button.closest('.mj-miri');
    const status = container && container.querySelector('[data-miri-chat-status]');
    requestedButton = button;
    clearTimeout(openTimeout);
    if (status) status.textContent = T('Der Chat wird geöffnet …');
    window.$chatty.push(['do', 'chat:show']);
    window.$chatty.push(['do', 'chat:open']);
    openTimeout = setTimeout(() => {
      if (status) status.textContent = T('Der Chat ist gerade nicht erreichbar. Schreib uns gern an info@mirjo.ch.');
    }, 7000);
  });
})();
